define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/xml"
], function(declare, lang, config, Field, Widget, xml) {

	const SPECIFICATION_DATASHEET = "SpecificationDataSheet";
	return declare(Widget, {
		/**
		 * Populate the Node Name Field with the name of subtype
		 */
		onChangeSubType: function(defView, field, value) {
			var dataSheetName = this.defView.getFieldValue(xml.ATTR_NAME);

			if (!dataSheetName || config.getSubtypeUrlByName(SPECIFICATION_DATASHEET, dataSheetName)) {
				this.setFieldValue(xml.ATTR_NAME, config.getSubtypeName(value));
			}
		},

		/**
		 * Add Subtype field
		 */
		_resolveView: function() {
			this.insertField(lang.mixin(new Field(), {
				m_id: "Subtype",
				m_onChange: "onChangeSubType"
			}), 0);

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Filter to remove subtypes that don't have the correct ApplicableForTypes for current view
		 */
		getFieldStore: function(field, value) {
			if (field.getControlName() === "Subtype" && !this.isEdit()) {
				const viewNodeType = this.getSourceView().getViewNodeType();
				// Spec types with ApplicableForTypes for Food should work for FoodSKU
				const nodeType = viewNodeType == "FoodSKU" ? "Food" : viewNodeType;
				const applicableForTypesEnum = (nodeType && nodeType != "_CS_Data") ? xml.enumCreate("Spec.ApplicableForTypes", nodeType) : null;
				if (applicableForTypesEnum) {
					return config.getSubtypeStore(SPECIFICATION_DATASHEET, (subtypeSettings) => {
						if (subtypeSettings.ApplicableForTypes) {
							return subtypeSettings.ApplicableForTypes.includes(applicableForTypesEnum);
						} else {
							return true;
						}
					});
				} else {
					return config.getSubtypeStore(SPECIFICATION_DATASHEET);
				}
			}
			return this.inherited(arguments);
		}
	});
});